import { useQuery } from 'urql';

import { graphql } from '@/__generated__';

const GetJobBasedExposureQuery = graphql(/* GraphQL */ `
  query GetJobBasedExposure($name: String!, $jobId: BigInt!) {
    job(id: $jobId) {
      exposure(name: $name) {
        jobId
        accountId
        projectId
        uniqueId
        parentsSources {
          state
          snapshottedAt
          tests {
            state
          }
        }
        parentsModels {
          tests {
            state
          }
        }
      }
    }
  }
`);

type JobBasedExposureProps = {
  name: string;
  jobId: number;
  pause?: boolean;
};

export const useJobBasedExposureQuery = ({
  jobId,
  name,
  pause,
}: JobBasedExposureProps) => {
  return useQuery({
    query: GetJobBasedExposureQuery,
    variables: { jobId, name },
    pause: pause || !jobId || !name,
  });
};

export type JobBasedExposure = NonNullable<
  ReturnType<typeof useJobBasedExposureQuery>[0]['data']
>;

export type JobBasedSourceNode = NonNullable<
  NonNullable<JobBasedExposure['job']>['exposure']
>['parentsSources'][number];
